import { Dispatch, StoreEnhancer } from 'redux';
import { isBrowser } from 'utils';
import { setMqCookie } from './actions';
import { queries } from './mediaQuery';

export const enhancer = (): StoreEnhancer => next => (reducer, preloadedState) => {
  const store = next(reducer, preloadedState);
  if (!isBrowser()) {
    return { ...store };
  }

  Object.entries(queries).forEach(([query, action]) => {
    const match: MediaQueryList = matchMedia(query);
    const handler = (ev: MediaQueryListEvent) => {
      if (ev.matches) {
        (store.dispatch as Dispatch)(action);
        setMqCookie(action.breakpoint);
      }
    };

    match.addEventListener('change', handler);
  });

  return { ...store };
};
